import React, { useState } from "react";
import {
  Button,
  Container,
  FormControl,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/safe.png";

function MerchantSignUp() {
  // eslint-disable-next-line
  const [error, setError] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  // eslint-disable-next-line
  const [token, setToken] = useState(""); // State to store the token
  const navigate = useNavigate();
  const handleSignUpClick = () => {
    navigate("/merchant-login");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    /**Check if the password and confirmPassword match*/
    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: email, password: password }),
    };

    try {
      const response = await fetch(
        "http://127.0.0.1:3000/",
        options
      ); /**Replace with backend endpoint*/
      if (response.ok) {
        const responseData = await response.json();
        const authToken = responseData.token;

        // Store the token in the state
        setToken(authToken);

        // Redirect to the merchant login page
        navigate("/merchant-login");
      } else {
        const errorResponse = await response.json();
        setError(
          errorResponse.message ||
            "Something went wrong. Please try again later."
        );
      }
    } catch (error) {
      console.error("Failed to fetch", error);
      setError("Server error occurred. Please try again later.");
    }
  };

  return (
    <Container maxWidth="sm" className="min-h-screen flex items-center mr-2">
      <div className="flex flex-col-reverse justify-between sm:flex-row ml-10">
        <div className="p-4 w-5/6 h-full">
          <div className="h-full">
            <Typography
              variant="h3"
              align="center"
              className="mb-4 text-success"
              gutterBottom
            >
              Sign Up
            </Typography>
            <Typography
              variant="subtitle1"
              align="center"
              className="mb-4 text-gray-500"
              gutterBottom
            >
              Enter your account details.
            </Typography>
            <form onSubmit={handleSubmit}>
              <FormControl fullWidth sx={{ marginBottom: 4 }}>
                <TextField
                  label="Email"
                  type="email"
                  variant="outlined"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="mb-3"
                  required
                />
              </FormControl>

              <FormControl fullWidth sx={{ marginBottom: 1 }}>
                <TextField
                  label="Password"
                  type="password"
                  variant="outlined"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="mb-3"
                  required
                />
              </FormControl>

              <FormControl fullWidth sx={{ marginBottom: 1 }}>
                <TextField
                  label="Confirm Password"
                  type="password"
                  variant="outlined"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className="mb-3"
                  required
                />
              </FormControl>
              <div className="mt-4 flex flex-row items-center justify-between mb-4">
                <Typography variant="body2" className="text-gray-500 mr-2">
                  Forgot your password?
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  style={{ width: "100px" }}
                  onClick={handleSubmit}
                >
                  Reset
                </Button>
              </div>

              <Button
                variant="contained"
                color="primary"
                type="submit"
                className="mt-4"
                fullWidth
                onClick={handleSubmit}
              >
                Sign Up
              </Button>
            </form>
          </div>
          <div className="mt-4 flex flex-row items-center justify-between">
            <Typography variant="body2" className="text-gray-500 mr-2">
              Already registered?
            </Typography>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              style={{ width: "100px" }}
              onClick={handleSignUpClick}
            >
              Log In
            </Button>
          </div>
        </div>
        <div className="w-3/4 p-4 h-full sm:mx-auto">
          <Typography variant="h3" align="center" className="mb-4 text-success">
            Welcome Back,
          </Typography>
          <Typography
            variant="subtitle1"
            align="center"
            className="mb-4 text-gray-500"
          >
            Ease and Authenticate your transaction with Salama pay
          </Typography>
          <img src={logo} alt="logo" className="w-full h-full p-4" />
        </div>
      </div>
    </Container>
  );
}

export default MerchantSignUp;
